import { RouteRecordRaw } from 'vue-router';
import { MenuItem } from '@/router/menuItem';
import { AppIcons } from '@/common';
import { isFeatureEnabled } from '@/router/featureFlags';

export const homeMenuItems: MenuItem[] = [
    {
        icon: AppIcons.map,
        text: 'Chart',
        to: { name: 'Map' },
    },
    {
        icon: 'mdi-magnify',
        text: 'Find',
        to: { name: 'Find' },
    },
    {
        icon: AppIcons.checklist,
        text: 'Tasks',
        to: { name: 'CatlTasks' },
        featureDisabled: !isFeatureEnabled('tasks'),
    },
    {
        icon: AppIcons.assets,
        text: 'Assets',
        to: { name: 'CatlAssets' },
        featureDisabled: !isFeatureEnabled('assets'),
    },
    {
        icon: AppIcons.contacts,
        text: 'Contacts',
        to: { name: 'CatlContacts' },
    },
    {
        icon: 'mdi-chart-timeline',
        text: 'Timeline',
        to: { name: 'CatlTimeline' },
        featureDisabled: !isFeatureEnabled('timeline'),
    },
    {
        icon: AppIcons.controlMeasures,
        text: 'Control Measures',
        to: { name: 'CatlControlMeasures' },
        featureDisabled: !isFeatureEnabled('controlMeasures'),
    },
    {
        icon: AppIcons.assets,
        text: 'Asset Types',
        to: { name: 'CatlAssetTypes' },
        featureDisabled: !isFeatureEnabled('assetTypes'),
    },
    {
        icon: AppIcons.assets,
        text: 'Sensor Types',
        to: { name: 'CatlSensorTypes' },
        featureDisabled: !isFeatureEnabled('sensorTypes'),
    },
    {
        icon: AppIcons.requests_for_collection,
        text: 'Request for Collection',
        to: { name: 'CatlRfc' },
        featureDisabled: !isFeatureEnabled('rfc'),
    },
    {
        icon: 'mdi-magnify-scan',
        text: 'Intel',
        to: { name: 'IntelSources' },
        featureDisabled: !isFeatureEnabled('intel'),
    },
    {
        icon: 'mdi-map-search-outline',
        text: 'JIPOE',
        to: { name: 'Jipoe' },
        featureDisabled: !isFeatureEnabled('jipoe'),
    },
    {
        icon: 'mdi-file-document-edit-outline',
        text: 'Plan Editor',
        to: { name: 'PlanEditor' },
        featureDisabled: !isFeatureEnabled('planEditor'),
    },
    // Ocean 3D (2026-10-15): GEBCO + Mapbox terrain in WebGPU with a
    // draggable CTD cross-section (T, S, C, σθ, c), sound-channel
    // detection and range-dependent Bellhop rays / TL on the section.
    // Its Sound speed tab replaced the old Bellhop page's SSP pane.
    {
        icon: 'mdi-cube-scan',
        text: 'Ocean 3D',
        to: { name: 'Ocean3d' },
        featureDisabled: !isFeatureEnabled('ocean3d'),
    },
    // Detections timeline (2026-10-13): per-glider swimlanes of Jasco's
    // RAW detections (detections.raw — base tables, so unlocated rows
    // count too), bearing colour wheel, frequency mode, ground-truth
    // actuals.  Supersedes the /detections page retired 2026-09-09; the
    // timeline is a self-contained component so the map's Analysis Mode
    // can dock the same thing rather than keep a second visualiser.
    {
        icon: 'mdi-waveform',
        text: 'Detections',
        to: { name: 'Detections' },
        featureDisabled: !isFeatureEnabled('detections'),
    },
    // Targets by day (2026-10-15): per UTC day, which underwater targets
    // ran (trial plan vs. ground-truth / own-nav tracks) and what the
    // detectors assigned to each that day heard.  targets.daily.
    {
        icon: 'mdi-target',
        text: 'Targets',
        to: { name: 'Targets' },
        featureDisabled: !isFeatureEnabled('targets'),
    },
    // Admin: system-level configuration + integration surfaces.  AIS and
    // STANAG-4817 used to be top-level entries; they moved in here because
    // they are configured once per operation rather than opened per-shift.
    {
        text: 'Admin',
        icon: 'mdi-shield-account',
        children: [
            {
                icon: 'mdi-tune-variant',
                text: 'Operation setup',
                to: { name: 'AdminOperationSetup' },
            },
            {
                icon: 'mdi-waveform',
                text: 'Jasco',
                to: { name: 'AdminJasco' },
                featureDisabled: !isFeatureEnabled('jasco'),
            },
            {
                icon: 'mdi-account-multiple',
                text: 'Users',
                to: { name: 'Users' },
            },
            {
                icon: 'mdi-account-key',
                text: 'Permissions',
                to: { name: 'Permissions' },
            },
            {
                icon: 'mdi-ferry',
                text: 'AIS',
                to: { name: 'Ais' },
            },
            {
                icon: 'mdi-file-import-outline',
                text: 'STANAG-4857',
                to: { name: 'Stanag4617' },
            },
            {
                icon: 'mdi-layers-outline',
                text: 'Map Layers',
                to: { name: 'AdminMapLayers' },
            },
            {
                icon: 'mdi-account-eye',
                text: 'Scenario sessions',
                to: { name: 'ScenarioSessions' },
            },
        ],
    },

    // Generally leave this commented out, but uncomment if you want to see the link to this
    // page which is purely to aid development of the icon code generation backend.
    // {
    //     to: { name: 'DevelopmentIconCodeGeneration' },
    //     text: 'DEVELOPMENT - Icon Code Generation',
    // },
    /*
    {
        text: 'Global Carrier Fleet',
        icon: AppIcons.fleet,

        children: [
            {
                to: { name: 'GlobalCarrierTypes' },
                cypressName: Ui.APP_MENU_BUTTON_CARRIER_TYPES,
                icon: AppIcons.carrierTypes,
                text: 'Carrier Types',
            },
            {
                to: { name: 'GlobalFleet' },
                cypressName: Ui.APP_MENU_BUTTON_FLEET,
                icon: AppIcons.fleet,
                text: 'Carrier Fleet',
            },
        ],
    },*/
];

export const HomeRoute: RouteRecordRaw[] = [
    {
        path: '/',
        component: () => import('@/home/TheHomePage.vue'),
        name: 'Home',
        meta: {
            guestFeatureAccess: true,
        },
    },
];
